<div class="d-flex justify-content-center align-items-center" id="main">
    <h1 class="mr-3 pr-3 align-top border-right inline-block align-content-center">401</h1>
    <div class="inline-block align-middle">
        <h2 class="font-weight-normal lead" id="desc" data-testid="title-not-authorized" >{{'You are not authorized to access this page' | translate}}.</h2>
    </div>
</div>